import React, { useContext } from "react";
import FormType, { FieldConfigs } from "../../../shared/components/FormType";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";
import { ContentWrapper } from "../../Material/create/Styled";

interface SingleMaterialProps {
    kpi: any;
    mergeKpi: Function;
    validated: boolean;
    kpiFields: FieldConfigs[];
}

export const SingleKpi = ({
                              kpi,
                              mergeKpi,
                              validated,
                              kpiFields,
                          }: SingleMaterialProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const getFields = () => {
        switch (role) {
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
            case ROLE.DELIVERER:
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.FACTORY_STAFF:
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return kpiFields;
            default:
                return kpiFields;
        }
    };

    return (
        <ContentWrapper>
            <FormType
                title={"Thông tin chỉ tiêu"}
                fields={getFields()}
                validated={validated}
                mergeFormData={mergeKpi}
                requireData={{
                    ...kpi,
                    name: kpi?.name,
                    subtype: kpi?.subtype,
                    target_value: kpi?.target_value,
                    duration: kpi?.duration,
                }}
            />
        </ContentWrapper>
    );
};
